import { Link } from "react-router-dom";
import cls from "../About.module.scss";
import { ORDER, titleKey } from "../data/map";
import i18n from "@/i18n";

export default function JumpMenu({ seen, order = ORDER, onSelect }) {
  return (
    <ul className={cls.listReset}>
      {order.map((id) => (
        <li key={id} className={seen?.[id] ? cls["is-seen"] : ""}>
          <Link to={`/about-us/${id}`} onClick={onSelect}>
            <span className={cls.dot} />
            {i18n.t(titleKey(id), { defaultValue: id })} {/* fallback = id */}
          </Link>

          {/* Big close button after “Join Us” (your existing logic) */}
          {id === "whatMakesNotyUniverseATrustedCommunity" && (
            <button
              type="button"
              className={cls.drawerCloseBig}
              onClick={onSelect}
            >
              {i18n.t("about.cChapters")}
            </button>
          )}
        </li>
      ))}
    </ul>
  );
}
